module.exports = __webpack_public_path__ + "static/media/wx-menu.60f906f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wx-menu.png
// module id = 209
// module chunks = 4